import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Breadcrums from "../../common/breadcrumbs";
import Loader from "../../common/loader";
import { getPaymentSummary } from "../../services/paymentManagement.services";

const PaymentSummary = () => {
    const { t } = useTranslation();
    const [summary, setSummary] = useState({});
    const [loader, setLoader] = useState(true);

    const breadcrumbs = [
        { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
        { title: t("Summary"), url: "" },
    ];

    useEffect(() => {
        setLoader(true);
        getPaymentSummary()
            .then((res) => {
                if (res.success) {
                    setSummary(res.data);
                }
                setLoader(false);
            })
            .catch((err) => {
                console.error(err);
                setLoader(false);
            });
    }, []);

    if (loader) {
        return <Loader />;
    }

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <div className="animation_fade">
                <div className="row g-4 mb-5">
                    <div className="col-md-3">
                        <div className="card custom-card border-0 shadow-sm h-100">
                            <div className="card-body">
                                <h5 className="card-title text-muted text-uppercase fs-12">Gateway Total</h5>
                                <p className="card-text fs-2 fw-bold text-success">
                                    ₹{summary.gateway_total || "0.00"}
                                </p>
                                <div className="progress progress-sm mt-3">
                                    <div className="progress-bar bg-success w-100" role="progressbar"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="card custom-card border-0 shadow-sm h-100">
                            <div className="card-body">
                                <h5 className="card-title text-muted text-uppercase fs-12">Order Total</h5>
                                <p className="card-text fs-2 fw-bold text-primary">
                                    ₹{summary.order_total || "0.00"}
                                </p>
                                <div className="progress progress-sm mt-3">
                                    <div className="progress-bar bg-primary w-100" role="progressbar"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="card custom-card border-0 shadow-sm h-100">
                            <div className="card-body">
                                <h5 className="card-title text-muted text-uppercase fs-12">Wallet Recharges</h5>
                                <p className="card-text fs-2 fw-bold text-info">
                                    ₹{summary.total_recharge || "0.00"}
                                </p>
                                <div className="progress progress-sm mt-3">
                                    <div className="progress-bar bg-info w-100" role="progressbar"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="card custom-card border-0 shadow-sm h-100">
                            <div className="card-body">
                                <h5 className="card-title text-muted text-uppercase fs-12">Wallet Spending</h5>
                                <p className="card-text fs-2 fw-bold text-danger">
                                    ₹{summary.total_spending || "0.00"}
                                </p>
                                <div className="progress progress-sm mt-3">
                                    <div className="progress-bar bg-danger w-100" role="progressbar"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PaymentSummary;
